import { useIsDarkMode } from '@/app/theme/colorScheme'
import {
  LOGO_VIEWBOX,
  MARK_KNOCKOUT,
  MARK_PATH,
  MARK_TRANSFORM,
  WORDMARK_LINK_PATH,
  WORDMARK_NET_PATH,
  WORDMARK_TRANSFORM,
} from './brandGeometry'

const BRAND_ORANGE = '#ED4325'
const BRAND_GRAPHITE = '#363636'

interface BrandLogoProps {
  height: number
  /** Ekran o'quvchi uchun nom; yonida mahsulot nomi matn bo'lib tursa berilmaydi. */
  label?: string
}

// Rasm fayli emas, inline: sekin mobil tarmoqda alohida so'rov logotip o'rnini bir zum bo'sh qoldiradi.
export function BrandLogo({ height, label }: BrandLogoProps) {
  const isDark = useIsDarkMode()
  const width = Math.round((height * LOGO_VIEWBOX.width) / LOGO_VIEWBOX.height)
  const a11y = label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true }

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${LOGO_VIEWBOX.width} ${LOGO_VIEWBOX.height}`}
      focusable="false"
      style={{ display: 'block', flexShrink: 0 }}
      {...a11y}
    >
      <circle fill="#FFFFFF" {...MARK_KNOCKOUT} />
      <path fill={BRAND_ORANGE} fillRule="evenodd" transform={MARK_TRANSFORM} d={MARK_PATH} />
      <g transform={WORDMARK_TRANSFORM}>
        <path fill={BRAND_ORANGE} d={WORDMARK_NET_PATH} />
        <path fill={isDark ? '#FFFFFF' : BRAND_GRAPHITE} d={WORDMARK_LINK_PATH} />
      </g>
    </svg>
  )
}
